__turbopack_context__.v({
  "content": "ProducersOverview-module-scss-module__mS2eJW__content",
  "content-container": "ProducersOverview-module-scss-module__mS2eJW__content-container",
  "controls": "ProducersOverview-module-scss-module__mS2eJW__controls",
  "controls-container": "ProducersOverview-module-scss-module__mS2eJW__controls-container",
  "controls-content": "ProducersOverview-module-scss-module__mS2eJW__controls-content",
  "energy-type-button": "ProducersOverview-module-scss-module__mS2eJW__energy-type-button",
  "energy-type-filter": "ProducersOverview-module-scss-module__mS2eJW__energy-type-filter",
  "fixed": "ProducersOverview-module-scss-module__mS2eJW__fixed",
  "map": "ProducersOverview-module-scss-module__mS2eJW__map",
  "map-container": "ProducersOverview-module-scss-module__mS2eJW__map-container",
  "mobile-map-view": "ProducersOverview-module-scss-module__mS2eJW__mobile-map-view",
  "producer-info-sidebar-mobile": "ProducersOverview-module-scss-module__mS2eJW__producer-info-sidebar-mobile",
  "producers": "ProducersOverview-module-scss-module__mS2eJW__producers",
  "producers-container": "ProducersOverview-module-scss-module__mS2eJW__producers-container",
  "producers-content": "ProducersOverview-module-scss-module__mS2eJW__producers-content",
  "producers-overview": "ProducersOverview-module-scss-module__mS2eJW__producers-overview",
  "view-toggle": "ProducersOverview-module-scss-module__mS2eJW__view-toggle",
});
